__turbopack_context__.v({
  "container": "PageActions-module__0nVPAa__container",
  "list": "PageActions-module__0nVPAa__list",
  "wrapper": "PageActions-module__0nVPAa__wrapper",
});
